import { SuperAdmin } from "@/types";

interface AdminHeaderProps {
    user: SuperAdmin
}

export default function AdminHeader({user}: AdminHeaderProps) {
    return (
        <div className="bg-white shadow">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center py-6">
                    <h1 className="text-2xl font-bold text-gray-900">
                        Super Admin Dashboard
                    </h1>
                    <div className="text-sm text-gray-700">
                        <strong>{user.name}</strong> ({user.email_address})
                    </div>
                </div>
            </div>
        </div>
    )
}